import React from 'react'
import { DialogOverlay, DialogOverlayActions } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useEvent } from '@fs/zion-frontend-friends'
import PillButton from '../../../../lib/buttons/PillButton'

export default function AreYouSureArchiveOverlay({ onArchive, ...overlay }) {
  const [t] = useTranslation()

  const onClick = useEvent((onCallback) => {
    onCallback()
    overlay.close()
  })
  return (
    <DialogOverlay
      title={t('are-you-sure-overlay.heading', 'Are you sure?')}
      footer={
        <DialogOverlayActions>
          <PillButton onClick={() => onClick(overlay.close())} emphasis="low" linkName="Are You Sure: Cancel">
            {t('common-ui:cancel.action', 'Cancel')}
          </PillButton>
          <PillButton onClick={() => onClick(onArchive)} linkName="Dashboard: Archive Content Overlay">
            {t('dashboard.past-sessions.archive-button', 'Archive')}
          </PillButton>
        </DialogOverlayActions>
      }
      {...overlay}
      closeOnClickAway={false}
    >
      {t(
        'dashboard.are-you-sure-archive-overlay.content',
        'Archived content will no longer appear on the RootsTech site. If you archive something by mistake, contact the RootsTech team to have it restored.'
      )}
    </DialogOverlay>
  )
}
